import { get } from 'lodash';

export const getUserStudies = state => get(state, 'studies.userStudies', []);
